const permissions = {
  user: {
    create: {
      ownCompany: ["manager"],
      ownProject: ["owner"],
    },
    edit: {
      ownCompany: ["owner", "manager"],
    },
  },
  group: {
    create: ["owner", "manager"],
    edit: ["owner", "manager"],
  },
  formTemplate: {
    create: ["owner", "manager", "form_admin"],
    edit: ["owner", "manager", "form_admin"],
  },
  form: {
    create: ["owner", "manager", "form_admin", "form_user"],
    edit: ["owner", "manager", "form_admin", "form_user"],
  },
  task: {
    create: ["owner", "manager", "form_admin", "form_user"],
    cancel: [],
    delegate: ["owner", "manager", "form_admin", "form_user"],
  },
  project: {
    create: ["owner"],
    delete: ["owner"],
  },
  projectSetting: {
    edit: ["owner"],
  },
  workflow: {
    create: ["manager", "form_admin", "owner", "form_user"],
    read: ["manager", "form_admin", "owner", "form_user"],
  },
  company: {
    create: ["admin", "owner", "manager"],
    edit: ["admin", "owner", "manager"],
  },
};

export default permissions;
